import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import * as moment from 'jalali-moment';
import { CompleteFormService } from 'src/app/services/api/complete-form.service';
import { CriteriaService, GeneralService, GlobalService, LocalStorageService } from 'src/app/services/index.service';

@Component({
  selector: 'app-pie',
  templateUrl: './pie.component.html',
  styleUrls: ['./pie.component.scss']
})
export class PieComponent implements OnInit {
 Highcharts: typeof Highcharts = Highcharts
//  chartOptions: Highcharts.Options = {}
 @Input() pieChart:any;
 @Input() user:any;
 @Input() shortShow:boolean = false;
 @Input() exam:any;
 chartLIst:any = []
 point:any;
 outputType:string = '';
 public chartOptions: Highcharts.Options = <Highcharts.Options>{}
  constructor(
    private GeneralService:GeneralService,
    private completeForm:CompleteFormService,
    private globalService:GlobalService,
    private criteriaService:CriteriaService,
    private storageService:LocalStorageService
  ) {}
 
  ngOnInit(): void {
    // console.log('before : ',this.pieChart )
    this.outputType = this.pieChart.output_type
    let isSortable = this.pieChart.sortable
    this.createchartLIst()
    this.criteriaService.CanExit = true
    if(isSortable) this.sortChart() 
    let scoreValues = this.scoreArray() // replace with your actual data values
    let tooltipTexts = this.tooltipArray();
    this.chartOptions =  {
      series: [{
       type:'pie',
       name: '',
      //  colorByPoint: true,
       data: []
      }],
      tooltip: {
        formatter: function () {
          let point = this.point as any;
          return point.myTooltipText;
        }
      },
      chart: {
          type: 'pie'
      },
      title: {
          // text: 'Pie with Drilldown'
      },
      plotOptions: {
          pie:{
            allowPointSelect: true,
            cursor: 'pointer',
            colors:[],
          },
          series: {
              dataLabels: {
                  enabled: true,
                  // formatter: `{point.name}: {point.y}%`
              }
          }
      },
      
    }
    
    scoreValues.forEach((value:any ,index:any) => {
      let chart = this.chartLIst[index];
      (this.chartOptions as any).plotOptions.pie.colors.push(chart.color);
      (this.chartOptions as any).series[0].data.push({
        name: `${chart.show} (${this.GeneralService.ConvertToPr(value.toString())}${this.outputType=='PERCENTAGE'?'%':''})`,
        y: value,
        myTooltipText: tooltipTexts[index]
      });
    });
  }
  isBackButton(){
    return this.storageService.getData('formToQuiz')
  }
  getBackButtonUrl(){
    const obj:any = this.storageService.getData('formToQuiz')
    return `/miz/personal/khast/${obj.id}`
  }
  setStatusFormBackToForm(){
    const obj:any = this.storageService.getData('formToQuiz')
    this.storageService.setData('formToQuiz',{...obj, status:'RETURNING'})
  }
  getTimePerMinutes(time:string){
    return this.globalService.convertTime(time)
  }
  returnLastTakeExamDay(data:any){
    let NDay:any;
    let lastExamTime = Date.parse(moment(data,'YYYY/M/D HH:mm:ss').format('YYYY/M/D HH:mm:ss'))
    let newDateTime = Date.parse(moment(new Date(),'YYYY/M/D HH:mm:ss').format('YYYY/M/D HH:mm:ss'))
    let n_diff = (newDateTime-lastExamTime)/(1000 * 60 * 60 * 24)
    if(n_diff<=1){
      NDay = 'امروز'
    }else if(n_diff > 1 && n_diff < 1.5){
      NDay = 'دیروز'
    }else{
      let round = Math.ceil(n_diff)
      NDay = `${round} روز قبل` 
    }
    return NDay
  }
  scrollToTop(){
    this.globalService.scrollTop()
    this.completeForm.setBackButton(null)
  }
  tooltipArray(){
    // console.log(this.chartLIst)
    let arr:string[] = [];
    this.chartLIst.forEach((item:any) => {
      arr.push(
        `
          <div class='flex items-center justify-start flex-col text-white'>
            <p class='inline-block font-extrabold text-lightMode-900 title-label'>${item.charType.type_explain} (${this.GeneralService.ConvertToPr(item.score.toString())}${this.outputType=='PERCENTAGE'?'%':''})</p><br>
            <p class='text-xs text-lightMode-600 tooltip-description'>
              ${item.charType.type_description}
            </p>
          </div>
        `
      )
    })
    return arr;
  }
  scoreArray(){
    // console.log(this.pieChart)
    let sum:any = 0;
    let arr:number[] = [];
    this.chartLIst.forEach((item:any) => {
      // console.log(item.score)
      arr.push(item?.score)
      if(item?.score){
      }
    })
    // console.log(arr)

    arr.forEach((i) => {sum=sum+i})
    arr.forEach((v,i) => {
      arr[i]=Math.floor((v/sum)*100) 
    })

    this.chartLIst.forEach((item:any,i:any) => {
      if(item?.score){
        item.score = arr[i]
      }
    })
    let arrSum = this.sum(arr);
    let difference:number = 0;
    if(arrSum<100){
      difference = 100 - arrSum;
      arr[arr.length - 1] = arr[arr.length - 1] + difference
      this.chartLIst[this.chartLIst.length - 1]!.score = this.chartLIst[this.chartLIst.length - 1]?.score + difference;
    }else if(arrSum>100){
      difference = arrSum - 100;

      arr[arr.length - 1] = arr[arr.length - 1] - difference
      this.chartLIst[this.chartLIst.length - 1].score = this.chartLIst[this.chartLIst.length - 1].score - difference 
    }
    // console.log(this.chartLIst)
    // console.log(arr)
    return arr;
  }
  sum(arr:any){
    let sum = 0;
    arr.forEach((s:number) => sum=sum+s)    
    return sum
  }
  createchartLIst(){
    for(let i in Object.values(this.pieChart)){
      if(Object.values(this.pieChart)[i]!="PERCENTAGE" && Object.keys(this.pieChart)[i]!="chart_color" && Object.values(this.pieChart)[i]!="NUMBER" && Object.values(this.pieChart)[i]!="PIE" && typeof Object.values(this.pieChart)[i]!='boolean'){
        this.chartLIst.push(Object.values(this.pieChart)[i])
      }
    }
  }
  createLabelName(char:any,score:number){
    return `
    <p class='text-center text-[0.95rem]'>${char}</p>
    <br><br>
    <p class='mt-3 text-center text-[0.85rem]'>${this.GeneralService.ConvertToPr(score.toString())} %</p>
    `
  }
  onSelect(data:any): void {
    // console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data:any): void {
    // console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data:any): void {
    // console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }

  labelFormatting(name:any) {
    return name;
  }

  getCharType(){
    let charType:string[] = [];
    
    this.chartLIst.forEach((item:any) => {if(item.show) charType.push(item.show)})
    return charType.join('')
  }
  sortChart(){
    let sortedProducts = this.chartLIst.sort(
      (p1:any, p2:any) => (p1.score < p2.score) ? 1 : (p1.score > p2.score) ? -1 : 0);
    this.chartLIst = sortedProducts
  }
}
